import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const setCalEventTemplateArchivedInputSchema = z.object({
    templateId: requiredUuidString('Template is required.', 'Invalid template ID.'),
    archived: z.boolean(),
});
//# sourceMappingURL=set-cal-event-template-archived-input.js.map